import React, { useEffect, useRef, useState } from 'react'
import { DialogTitle, Dialog, DialogContent, TextField, IconButton, Grid, DialogActions, Button, MenuItem, Autocomplete, Box } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import axios from 'axios';
export default function OutSideCarsForm({ handleChangeCarsOutside, data }) {


  const [open, setOpen] = useState(false);

  const [vehicle_id, setVehicleId] = useState('');
  const [inputvehicle_id, setInputVehicleId] = useState('');

  const [company, setcompany] = useState('');
  const [inputcompany, setInputcompany] = useState('');

  const [type_car, settype_car] = useState('');


  const [errors, setErrors] = useState({
    errorV: false,
    errorT: false,
    errorC: false,
  });




  const [options, setOptions] = useState([]);


  const [carsOption, setCarsOption] = useState({
    car_type: []
  });

  useEffect(() => {
    if (data) {
      setVehicleId(data?.vehicle_id)
      setcompany(data?.company)
      settype_car(data?.type_car)
    }
  }, [data])




  useEffect(() => {
    if (open) {
      axios.get(`https://api.sitbooking.com/booking/get_car_options`)
        .then(res => {
          setCarsOption({
            ...res.data
          })
        })
        .catch(err => {
          console.log('err', err)
        })
    }

  }, [open])



  useEffect(() => {
    if (inputvehicle_id !== "") {
      axios.get(`https://api.sitbooking.com/booking/get_car?search=${inputvehicle_id}`)
        .then(res => {
          setOptions(
            res.data
          )
        })
        .catch(err => {
          console.log('err', err)
        })
    }
  }, [inputvehicle_id])


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setErrors({
      errorV: false,
      errorT: false,
      errorC: false,
    });

    setVehicleId('');
    setInputVehicleId('');
    setcompany('');
    setInputcompany('');
    settype_car('');
  };

  const onSubmitForm = (e) => {
    const newErrors = {
      errorV: vehicle_id === "",
      errorT: company === "",
      errorC: type_car === "",
    };

    const hasError = Object.values(newErrors).some((err) => err);
    if (hasError) {
      return;
    } else {
      const _vehicle_id = typeof vehicle_id === 'string' ? vehicle_id : vehicle_id?.vehicle_id
      const payload = { vehicle_id: _vehicle_id, company, type_car };
      handleChangeCarsOutside(payload)
      handleClose()
    }
  }

  return (
    <div>
      <IconButton onClick={handleClickOpen}><AddBoxIcon /></IconButton>
      <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
        <DialogTitle>รายละเอียดรถ</DialogTitle>
        <DialogContent >
          <Box sx={{ padding: "10px" }}>
            {/* <form ref={formRef} onSubmit={onSubmitForm} style={{ padding: "10px" }}> */}
            <Grid container spacing={1} >
              <Grid item xs="12" >
                <Autocomplete
                  freeSolo
                  options={options}
                  value={vehicle_id}
                  inputValue={inputvehicle_id}
                  getOptionLabel={(option) => {
                    if (typeof option === 'string') return option;
                    if (option?.vehicle_id) return option.vehicle_id;
                    return '';
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (typeof value === 'string') {
                      return option.vehicle_id === value;
                    }
                    return option.vehicle_id === value.vehicle_id;
                  }}
                  onInputChange={(event, newInputValue) => {
                    setInputVehicleId(newInputValue);
                    setVehicleId(newInputValue)
                  }}
                  onChange={(event, newValue) => {
                    setVehicleId(newValue ?? inputvehicle_id);
                    setcompany(newValue?.owner);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="ทะเบียนรถ" variant="outlined" size="small" required
                      error={errors.errorV}
                      helperText={errors.errorV ? 'กรุณากรอกทะเบียนรถ' : ''}
                    />
                  )}
                />
              </Grid>
              <Grid item xs="12" >
                <TextField fullWidth label="ผู้ประกอบการ" variant="outlined" size="small" required value={company}
                  onChange={(event) => {
                    setcompany(event.target.value);
                  }}
                  error={errors.errorC}
                  helperText={errors.errorC ? 'กรุณากรอกผู้ประกอบการ' : ''}
                />
              </Grid>
              <Grid item xs="12" >
                <TextField size="small" fullWidth label="ประเภทรถ" select required value={type_car}
                  onChange={(event) => {
                    settype_car(event.target.value);
                  }}
                  error={errors.errorT}
                  helperText={errors.errorT ? 'กรุณากรอกประเภทรถ' : ''}
                >
                  {
                    carsOption.car_type.map((val, index) => {
                      return (
                        <MenuItem key={`TYPE-${index}`} value={val.car_type_name}>{val.car_type_name}</MenuItem>
                      )
                    })
                  }
                </TextField>
              </Grid>
            </Grid>
          </Box>
          {/* </form> */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onSubmitForm}
          >ตกลง</Button>
        </DialogActions>
      </Dialog>
    </div >
  )
}
